import { createThemes } from "../../../../../../../styles/common/themes.js";
import universalMusicRadioButtonStyles from "./styles/partnershipsUniversalMusic.js";
const radioButtonThemes = createThemes({
    partnershipsUniversalMusic: universalMusicRadioButtonStyles
});
export default radioButtonThemes;

//# sourceMappingURL=index.js.map